function moveOnAppear(targetSelector, parentSelector, childSelector, useTargetParent = false) {
  const tryMove = () => {
    const target = document.querySelector(targetSelector)
    if (!target) return false

    const nodeToInsert = useTargetParent ? target.parentElement : target
    if (!nodeToInsert) return false

    const parent = document.querySelector(parentSelector)
    if (!parent) return false

    const beforeChild = parent.querySelector(childSelector)
    if (!beforeChild) return false

    parent.insertBefore(nodeToInsert, beforeChild)
    return true
  }

  // Try immediately in case elements already exist
  if (tryMove()) return

  const observer = new MutationObserver(() => {
    if (tryMove()) observer.disconnect()
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

// Use with your current selectors:
// - target element to observe
// - parent container to insert into
// - child (inside parent) to insert before
// - useTargetParent: true to use the target's parent, false to use the target itself
moveOnAppear('.rb-incentives-status__container', '.rb-sticky-content', '.tflex-column', true)
console.log('isSmall', isSmall.matches)
if (!isSmall.matches) moveOnAppear('.rb-subscribe-and-save-container', '.rb-sticky-content', '.rb-container.tmb3')

// clear cart once on load
cartClear()

// watch data-rb-added and keep track of changes
const observeRbAdded = () => {
  const targetNode = document.querySelector('.status-bar-sign-up')

  if (!targetNode) {
    console.log('Target node not found yet')
    return
  }

  const config = {
    attributes: true,
    attributeFilter: ['data-rb-added'],
    subtree: true,
  }

  const callback = mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-rb-added') {
        const newValue = Number(mutation.target.getAttribute('data-rb-added'))
        console.log('data-rb-added changed to', newValue)

        // Apply the disabled state multiple times to catch Vue re-renders
        const applyButtonState = () => {
          const addToCartButton = document.querySelector('#build-a-box .rb-sticky-content .rb-form .rb-btn')
          if (!addToCartButton) return

          if (newValue < 3) {
            console.log('Disabling Add to Cart button, only', newValue, 'items added')
            addToCartButton.classList.add('disabled')
            addToCartButton.disabled = true
          } else {
            console.log('Enabling Add to Cart button,', newValue, 'items added')
            addToCartButton.classList.remove('disabled')
            addToCartButton.disabled = false
          }
        }

        // Apply immediately
        applyButtonState()

        // Retry after Vue re-renders (staggered timing to catch it)
        setTimeout(applyButtonState, 50)
        setTimeout(applyButtonState, 150)
        setTimeout(applyButtonState, 300)
      }
    }
  }

  const observer = new MutationObserver(callback)
  observer.observe(targetNode, config)

  console.log('MutationObserver started watching for data-rb-added changes')
}

// Try to initialize, or wait for the element to exist
if (document.querySelector('.status-bar-sign-up')) {
  observeRbAdded()
} else {
  // Wait for the third-party JS to create the element
  const checkExist = setInterval(() => {
    if (document.querySelector('.status-bar-sign-up')) {
      clearInterval(checkExist)
      observeRbAdded()
    }
  }, 100)
}
